import { Link } from 'react-router-dom';
import logo from '../../assets/lis-logo.png';
import udeaLogo from '../../assets/udea-facultad-ingenieria.png';
import Icon, { IconName } from '../Icon/Icon';
import './Footer.css';

const socials: { id: IconName; label: string; href: string }[] = [
  { id: 'discord', label: 'Discord', href: 'https://discord.gg/cSg9wUJuJC' },
  { id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/sistemasudea/' },
  { id: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/LISUdeA' },
  { id: 'x', label: 'X', href: 'https://twitter.com/DsistemasUdeA' },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="lis-container footer-grid">
        <section aria-labelledby="footer-lis-title">
          <div className="footer-brand">
            <img src={logo} alt="" className="footer-logo" />
            <div>
              <h2 id="footer-lis-title">LIS</h2>
              <p>Laboratorio Integrado de Sistemas</p>
            </div>
          </div>
          <p className="footer-institution">Departamento de Ingeniería de Sistemas<br />Facultad de Ingeniería<br />Universidad de Antioquia</p>
          <div className="footer-socials" aria-label="Redes sociales">
            {socials.map(({ id, label, href }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} title={label}>
                <Icon name={id} />
              </a>
            ))}
          </div>
        </section>

        <nav aria-label="Enlaces rápidos">
          <h2 className="footer-heading">Enlaces rápidos</h2>
          <ul className="footer-links">
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/#laboratorios">Laboratorios</Link></li>
            <li><Link to="/#comunidad">Comunidad</Link></li>
            <li><Link to="/#recursos">Recursos educativos</Link></li>
            <li><Link to="/assistants">Auxiliares</Link></li>
            <li><Link to="/lispresta">LIS-Presta</Link></li>
          </ul>
        </nav>

        <section aria-labelledby="footer-contact-title">
          <h2 id="footer-contact-title" className="footer-heading">Contacto</h2>
          <address className="footer-contact">
            <p><Icon name="map-pin" /><span>Calle 67 No. 53 - 108, oficina 18-210<br />Medellín - Colombia</span></p>
            <p><Icon name="phone" /><span>(+57 604) 219 5532</span></p>
            <p><Icon name="mail" /><a href="mailto:laboratorio.lis@udea.edu.co">laboratorio.lis@udea.edu.co</a></p>
            <p><Icon name="mail" /><span>Recepción de correspondencia:<br />Calle 70 No. 52 - 21 · Apartado Aéreo 1226</span></p>
          </address>
        </section>
      </div>
      <div className="footer-institutional">
        <div className="lis-container footer-institutional-inner">
          <img src={udeaLogo} alt="Universidad de Antioquia — Facultad de Ingeniería" className="footer-institutional-logo" />
          <p className="footer-institutional-name">
            Laboratorio Integrado de Sistemas · Departamento de Ingeniería de Sistemas · Universidad de Antioquia
          </p>
          <p className="footer-institutional-detail">
            Medellín - Colombia · Dirección: calle 67 No. 53 - 108 · Teléfono: (+57 604) 219 5532 · Oficina: 18-210
          </p>
          <p className="footer-institutional-detail">
            Recepción de correspondencia: calle 70 No. 52 - 21 · Apartado Aéreo 1226
          </p>
          <p className="footer-institutional-copy">
            © {year} Laboratorio Integrado de Sistemas · Departamento de Ingeniería de Sistemas
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
